import Selectable from './Selectable';

export default Selectable;
